import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '@atmi/shared';
import { FormModule } from '@sim/form';
import { UiModule } from '@ui/ui.module';

import { FiltersComponent } from './components/filters/filters.component';
import { UserManagerComponent } from './components/user-manager/user-manager.component';
import { UsersComponent } from './components/users/users.component';
import { UserModuleConfiguration } from './models/configuration';
import { CheckRolePipe } from './pipes/check-role.pipe';
import { UsersApiService } from './services/users-api.service';
import { UserConfigurationService } from './token';

export * from './models/configuration';
export * from './models/user';
export * from './components/users/users.component';
export * from './components/user-manager/user-manager.component';
export * from './services/users-api.service';
export * from './token';

const routes: Routes = [
  {
    children: [
      {
        component: UsersComponent,
        path: '',
      },
      {
        component: UserManagerComponent,
        path: 'manager',
      },
      {
        component: UserManagerComponent,
        path: 'manager/:id',
      }
    ],
    path: '',
  },
];
@NgModule({
  declarations: [
    CheckRolePipe,
    FiltersComponent,
    UserManagerComponent,
    UsersComponent,
  ],
  exports: [
    FiltersComponent,
  ],
  imports: [
    CommonModule,
    UiModule,
    SharedModule,
    RouterModule.forChild(routes),
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormModule,
    ReactiveFormsModule,
  ],
})
export class UsersModule {
  static forRoot(config: UserModuleConfiguration): ModuleWithProviders<UsersModule> {
    return {
      ngModule: UsersModule,
      providers: [
        UsersApiService,
        { useValue: config, provide: UserConfigurationService },
        { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
      ]
    };
  }
}
